export const EMPTY_EDITOR_BLOCKS = {
  content: [
    {
      content: [],
      type: "paragraph",
    },
  ],
  type: "doc",
};
